import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの予約一覧を取得する
 *
 * @param {Number} uid ユーザID
 * @param {String} begin 検索開始日
 * @param {String} end 検索終了日
 * @param {Number} offset オフセット
 * @param {Number} limit 件数
 * @returns {Response} レスポンスデータ
 */
export function getUserReserves (uid, begin, end, offset, limit) {
  return request.get(`/users/${uid}/reserves`, {
    params: {
      s: begin,
      e: end,
      offset,
      limit
    },
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
